var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),_vm._v(" "),(!_vm.showingDetail)?_c('FundScreenerV2View',{class:{'tw-opacity-0': _vm.showingDetail}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }